import { FC } from 'react';

type Props = {
	className?: string;
};

const QuestionsIconSolidDuotone: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
				<path
					opacity='0.4'
					d='M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z'
					fill='#2B2B2B'
				/>
				<path
					d='M9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z'
					stroke='inherit'
					strokeWidth='1.25'
				/>
				<path
					d='M8.3335 7.50016C8.3335 6.57969 9.07966 5.8335 10.0002 5.8335C10.9207 5.8335 11.6668 6.57969 11.6668 7.50016C11.6668 7.83195 11.5699 8.1411 11.4027 8.40083C10.9047 9.17491 10.0002 9.913 10.0002 10.8335V11.2502'
					stroke='inherit'
					strokeWidth='1.25'
					strokeLinecap='round'
				/>
				<path
					d='M9.99316 14.167H10.0007'
					stroke='inherit'
					strokeWidth='1.66667'
					strokeLinecap='round'
					strokeLinejoin='round'
				/>
		</svg>
	);
};

export default QuestionsIconSolidDuotone;
